import { useEffect } from "react";
import { useRouter } from "next/router";

import * as Track from "@qoohoo/common/utils/analytics/track";
import { pageview } from "@qoohoo/common/constants/analytics";
import { addTagsInRecording } from "@qoohoo/common/utils/analytics/clarity";

const OneToOneThankYouModal = ({
  channelDetails,
  bookingUid,
  disableCloseModal,
}) => {
  const router = useRouter();

  const isPaid = channelDetails.is_paid;
  const current_screen = pageview.channel_details;
  const modal_name = "thank_you_modal";
  const trackDetails = {
    current_screen,
    modal_name,
    is_paid: isPaid,
    uid: channelDetails.uid,
    name: channelDetails.name,
    type: channelDetails.type,
    recurring_type: channelDetails?.plans?.[0]?.plan_type,
    "creator.uid": channelDetails.creator.uid,
    "creator.full_name": channelDetails.creator.fullname,
    "creator.username": channelDetails.creator.username,
  };

  useEffect(() => {
    disableCloseModal();
  }, []);

  useEffect(() => {
    addTagsInRecording({ thank_you_modal: true, ...trackDetails });
    Track.customEvent(modal_name, {
      actionType: "modal_open",
      label: modal_name,
      ...trackDetails,
    });
  }, []);

  useEffect(() => {
    if (bookingUid) {
      const timeout = setTimeout(() => {
        const bookingDetailsUrl = `/booking-details/${bookingUid}/`;
        router.push(bookingDetailsUrl);
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [bookingUid]);

  return (
    <>
      <div className="absolute w-full left-0 -top-10">
        <img
          className="mx-auto"
          src="/assets/icons/calendar-success.svg"
          alt="calendar success"
        />
      </div>

      <div className="text-4xl leading-8 font-bold mt-8">Thank You...</div>
      <p className="text-md text-[#F0F0F0] mt-4">
        Your slot is booked. You will receive an calendar invite on your email.
      </p>
      <p className="text-md text-[#F0F0F0] mt-16 flex items-baseline justify-center">
        Redirecting
        <span className="flex items-baseline gap-1 text-2xl ml-1">
          <span className="animate-loading-opacity animation-delay-200 w-[3px] h-[3px] rounded-full bg-[#f0f0f0]"></span>
          <span className="animate-loading-opacity animation-delay-400 w-[3px] h-[3px] rounded-full bg-[#f0f0f0]"></span>
          <span className="animate-loading-opacity animation-delay-600 w-[3px] h-[3px] rounded-full bg-[#f0f0f0]"></span>
        </span>
      </p>
    </>
  );
};

export default OneToOneThankYouModal;
